<template>
	<popup-dialog v-model="openModal">
		<v-row slot="header">
			<v-col>
				<span>הזנת דוח אקסל</span>
			</v-col>
			<v-spacer></v-spacer>
		</v-row>
		<v-btn slot="toolbar-items" color="green" href="/importExample.xlsx" target="_blank">דוח לדוגמא</v-btn>
		<form @submit.prevent="onSubmit">
			<c-card v-show="authIsClientManager || authIsAdmin">
				<h3 slot="title" color="green"> {{ $t("pages.orderForm.companyDetails") }}</h3>
				<cols-row md="4">
					<clients-select v-if="authIsAdmin" name="client_id" :clearable="false" :disable="disabledProject"
						v-model="form.client_id"/>
					<branches-select name="branch_id" :clearable="false" required :disable="disabledProject"
						v-if="form.client_id" lazy="client_id" :filters="{client_id: form.client_id}"
						v-model="form.branch_id"/>
				</cols-row>
			</c-card>
			<c-card>
				<h3 slot="title" color="green">{{ $t("pages.orderConsForm.projDetails") }}</h3>
				<cols-row md="6">
					<smart-input name="contractor" :error="inputErrors.contractor"
						:label="$t('pages.projectForm.contractor')" required
						v-model="form.contractor"
						:disabled="disabledProject"
					></smart-input>
					<smart-input name="name" :error="inputErrors.name" :disabled="disabledProject"
						:label="$t('pages.projectForm.projectName')"
						required v-model="form.name"></smart-input>
				</cols-row>
				<cols-row md="6">
					<smart-input name="contact" :disabled="disabledProject" :error="inputErrors.contact"
						:label="$t('pages.projectForm.contact')"
						required v-model="form.contact"></smart-input>
					<smart-input name="contact_tel" :disabled="disabledProject" :error="inputErrors.contact_tel"
						:label="$t('pages.orderTable.tel')"
						required v-model="form.contact_tel" :pattern="phonePattern" placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>
				</cols-row>

				<cols-row md="3">
					<smart-input name="contact2" :disabled="disabledProject" :error="inputErrors.contact"
						:label="$t('pages.orderConsForm.secondContact')" v-model="form.contact2" ></smart-input>
					<smart-input name="contact2_tel" :disabled="disabledProject" :error="inputErrors.contact_tel2"
						:label="$t('pages.orderTable.tel') + '  ' + $t('pages.orderConsForm.secondContact') "
						v-model="form.contact2_tel" :pattern="phonePattern" placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>
					<smart-input name="contact3" :disabled="disabledProject" :error="inputErrors.contact"
						:label="$t('pages.orderConsForm.thirdContact')" v-model="form.contact3"></smart-input>
					<smart-input name="contact3_tel" :disabled="disabledProject" :error="inputErrors.contact_tel3"
						:label="$t('pages.orderTable.tel') + '  ' + $t('pages.orderConsForm.thirdContact') "
						v-model="form.contact3_tel" :pattern="phonePattern" placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>
				</cols-row>

				<cols-row md="3">
					<smart-input name="address" :error="inputErrors.address" :disabled="disabledProject"
						:label="$t('pages.orderForm.measurementAddress')" required
						v-model="form.address"></smart-input>
					<cites-select name="city" v-model="form.city" :required="true" :disabled="disabledProject"/>
				</cols-row>
				<cols-row md="12">
					<div class="text-center">
						<v-file-input name="excel" accept=".xlsx" :rules="rules" required label="קובץ אקסל" show-size/>
					</div>
				</cols-row>
				<cols-row md="12">
					<div class="text-center">
						<!--            <v-file-input name="file_src[]" multiple label="קבצים" show-size/>-->
						<drag-and-drop name="file_src[]" :files="files"></drag-and-drop>
					</div>
				</cols-row>
			</c-card>
			<v-card>
				<v-card-actions>
					<v-btn type="submit" :loading="inProgress" color="success">שלח הזמנה</v-btn>
				</v-card-actions>
			</v-card>
		</form>
	</popup-dialog>
</template>

<script>
	import CitesSelect from "dev/view/measurements/CitesSelect";
	import CCard from "dev/scaffoldings/cCard";
	import ClientsSelect from "dev/view/clients/ClientsSelect";
	import BranchCard from "dev/view/branches/BranchCard";
	import BranchesSelect from "dev/view/branches/BranchesSelect";
	import ProjectModule from "src/store/modules/Project.module";
	import FormView from "dev/mixins/FormView";
	import ClientModule from "src/store/modules/Client.module";
	import DragAndDrop from "dev/components/DragNDrop";

	export default {
		name: "project-import-dialog",
		components: {BranchesSelect, ClientsSelect, CCard, CitesSelect, DragAndDrop},
		props: {
			value: {},
			disabledProject: {default: false},
		},
		mixins: [new FormView(ProjectModule, "project", true)],
		data() {
			return {
				form: {},
				phonePattern: "^[0-9]{2,3}-[0-9]{7}",
				files: [],
				inputErrors: {},
				rules: [
					value => !value || value.name.substr(value.name.lastIndexOf(".")) === ".xlsx" || "ניתן להעלות קבצים מסוג xlsx בלבד",
					value => !value || value.size < 4000000 || "גודל הקובץ חייב להיות עד 4 מגה"
				]
			};
		},
		computed: {
			openModal: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			},
			auth() {
				return this.$store.state.AuthModule.user;
			},
			authIsClient() {
				return this.$store.getters.isClient;
			},
			authIsAdmin() {
				return this.$store.getters.isAdmin;
			},
			authIsClientManager() {
				return this.$store.getters.isClientManager;
			},
			authIsBranchManager() {
				return this.$store.getters.isBranchManager;
			},
			authIsBranchClient() {
				return this.$store.getters.isBranchClient;
			},
			companyId() {
				return this.$store.state.AuthModule.user.company_id;
			},
		},
		methods: {
			beforeSubmit(formData) {
				let data = Object.assign({}, this.form,);
				formData.append("project", JSON.stringify(data));
				this.files.forEach((file) => {
					if (!file.id) {
						formData.append("file_src[]", file);
					}
				});
				return formData;
			},
			getDispatchType() {
				return ProjectModule.types.IMPORT;
			},
			onSuccess() {
				this.$notfication.success(this.getSuccessMessage());
				this.onReset();
				this.openModal = !this.openModal;
			}
		},
		created() {
			if (this.authIsClient) {
				this.form.client_id = this.auth.client_id;
				this.form.branch_id = this.auth.branch_id;
			}
			if (this.authIsBranchManager) {
				this.form.branch_id = this.auth.branch_id;
			}

		}
	};
</script>

<style scoped>

</style>
